<div class="d-flex listing-icons align-items-center justify-content-end">
    <div class="tile-list-view cursor expand-icon" *ngIf="!isExpand"><img
            src="../../../../assets/images/expand-icon.svg" title="Expand" (click)="onClick('expand')" class="h-30"
            alt="expand-view"></div>
    <div class="tile-list-view cursor expand-icon" *ngIf="isExpand"><img
            src="../../../../assets/images/collapse-icon.svg" title="Collapse" (click)="onClick('')" class="h-30"
            alt="collapse-view"></div>
</div>